export default __webpack_public_path__ + "static/media/marker_yellow.8b5c904c.png";